import {
  RadioButtonGroupMapping,
  RadioButtonType,
} from '@labrav/react-components'

import { OfferStatus } from '../types/flyout'

export enum ExpiryDateRangeStatus {
  FIVE = '5',
  FIFTEEN = '15',
  THIRTY = '30',
}

export const expiryDateMapping: RadioButtonGroupMapping[] = [
  {
    key: ExpiryDateRangeStatus.FIVE,
    label: 'Expiring in 5 days',
    type: RadioButtonType.STANDARD,
  },
  {
    key: ExpiryDateRangeStatus.FIFTEEN,
    label: 'Expiring in 15 days',
    type: RadioButtonType.STANDARD,
  },
  {
    key: ExpiryDateRangeStatus.THIRTY,
    label: 'Expiring in 30 days',
    type: RadioButtonType.STANDARD,
  },
]

export const awsPrivateOfferStatus: { [key: string]: string } = {
  'Offer sent': OfferStatus.PRIVATE_OFFER_EMAIL_SENT,
  'Offer accepted': OfferStatus.PRIVATE_OFFER_ACCEPTED,
  'Offer viewed': OfferStatus.PRIVATE_OFFER_VIEWED,
  Failed: OfferStatus.PRIVATE_OFFER_FAILED,
  Cancelled: OfferStatus.PRIVATE_OFFER_RESTRCITED,
  Expired: OfferStatus.PRIVATE_OFFER_EXPIRED,
}

export const microsoftPrivateOfferStatus: { [key: string]: string } = {
  'Offer sent': OfferStatus.OFFER_EMAIL_SENT,
  'Offer accepted': OfferStatus.OFFER_ACCEPTED,
  'Offer viewed': OfferStatus.OFFER_VIEWED,
  Failed: OfferStatus.OFFER_CREATION_FAILED,
  Deactivated: OfferStatus.OFFER_RESTRICTED,
  Expired: OfferStatus.OFFER_EXPIRED,
}
